import _classCallCheck from "/vercel/path2/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path2/node_modules/@babel/runtime/helpers/esm/createClass";

var Layers = /*#__PURE__*/function () {
  function Layers() {
    _classCallCheck(this, Layers);

    this.mask = 1 | 0;
  }

  _createClass(Layers, [{
    key: "set",
    value: function set(channel) {
      this.mask = 1 << channel | 0;
    }
  }, {
    key: "enable",
    value: function enable(channel) {
      this.mask |= 1 << channel | 0;
    }
  }, {
    key: "enableAll",
    value: function enableAll() {
      this.mask = 0xffffffff | 0;
    }
  }, {
    key: "toggle",
    value: function toggle(channel) {
      this.mask ^= 1 << channel | 0;
    }
  }, {
    key: "disable",
    value: function disable(channel) {
      this.mask &= ~(1 << channel | 0);
    }
  }, {
    key: "disableAll",
    value: function disableAll() {
      this.mask = 0;
    }
  }, {
    key: "test",
    value: function test(layers) {
      return (this.mask & layers.mask) !== 0;
    }
  }]);

  return Layers;
}();

export { Layers };